module.exports = {
  app: {
    isIpad:
      "BiP Games are currently avaliable in mobile devices, please try again on your mobile devices."
  },
  index: {
    game: "ゲーム",
    welfare: "Bonus",
    category: "カテゴリー",
    nav: "Games",
    seek: "検索",
    lb_title: "Compete!",
    lb_text: "improve and get rewarded",
    lb_button: "JOIN NOW !",
    lb_rank: "RANK",
    lb_prize: "PRIZE",
    lb_go: "GO",
    history_title: "最近遊んだゲーム",
    swiper_img: require("@/img/banner.jpg"),
    list_button: "PLAY NOW",
    player: "人",
    recommend: "Loading more recommend",
    nogame: "これ以上ゲームはありません",
    free: require("@/img/free.png"),
    Save: "Save",
    failed: "Save failed",
    success: "Saved successfully",
    newimg: require("@/img/new.png"),
    hotimg: require("@/img/hot.png"),
    Share: "Share",
    Sharegame: "Do you want to share this game?",
    open: "開く",
    More: "もっと",
    ad: "広告"
  },
  rank: {
    title: "総合ランキング"
  },
  activity: {
    my_rank: "MY RANK",
    my_points: "MY POINTS",
    task_name: "TASK NAME",
    rank_points: "POINTS",
    count: "COUNT",
    Treasure_chest: "Treasure chest",
    info: "INFO",
    rankinh: "HERKESE",
    reward: "REWARD",
    everyone: "EVERYONE GET",
    points: "POINTS",
    rules: "RULES",
    Waiting: "Waiting for you!",
    point: "point",
    part1: require("@/img/part1.png"),
    part2: require("@/img/part2.png"),
    Claim: "Claim"
  },
  activity_get: {
    title: "= Play games for benefits =",
    data_package: "Data package collected:",
    time: "Try at 1pm and 7pm everyday",
    obtain: "Obtain",
    obtained: "Obtained",
    Redeem: "Redeem rewards",
    Edit: "Edit Profile",
    event: "Redeem rewards after the event",
    rules: "RULES",
    list: [
      `Players who played "Shoot'em UP" can have one lucky draw chance to get data package on daily basis.`,
      `Lucky draw happens at 01:00 pm and 07:00 pm during the period.`,
      `The random data package obtained by players will be issued on Monday of each week.`,
      `Players using illegal ways to obtain data package will be disqualified.`
    ],
    check: "check your prize out",
    hint: "It has been collected. Please wait for the next period",
    bg_top: require("@/img/bg_1.png")
  },
  game_seek: {
    result: "結果なし",
    play: "play",
    Loading: "読み込み中"
  },
  site: {
    title: "Fill in information",
    site_title: "Please fill in below to claim the awards",
    username: "Name",
    phone: "Phone",
    address: "Delivery address",
    site_button: "Confirm",
    successfully: "Upload successfully",
    failed: "Upload failed"
  },
  name: {
    Confirm: "Confirm",
    Avatar: "Change Avatar "
  },
  iosIndex: {
    allgame: "All Games",
    history_title: "Recently Played"
  },
  config: {
    No_result: "No result",
    server: "Server is busy",
    loading: "Loading",
    no_loading: "Nothing down below!"
  },
  boon: {
    gold: "Gold coin",
    diamond: "Diamond",
    sing: "Coin Record",
    mysing: "My coin",
    chekin: "Signed in",
    no_chekin: "Sign in",
    chekin_text: "Continuous signed in",
    day: "Days",
    achievement: "Achievement center",
    check: "View",
    coming_soon: "coming soon",
    gold_mall: "Gold coin mall",
    quest: "Daily Quest",
    no_complete: "To complete",
    get: "Redeem",
    complete: "Finished",
    checked: "Signed in"
  },
  achievements: {
    gold: "Gold coin",
    diamond: "Diamond",
    achievement: "Achievement",
    get_prize: "Redeem"
  },
  Pay: {
    Current_Diamonds: "Current Diamonds",
    Billing_Breakdowns: "Billing Breakdown",
    Topup: "Topup",
    Consumption: "Consumption",
    Successful: "Payment Successful",
    Failure: "Payment Failure",
    Result: "Result",
    GO_BACK: "GO BACK",
    abnormity:
      "You have completed the payment,but the order query is abnormal,please try again later.",
    no_goods: "The item is not available currently. ",
    Network: "Network error, please try again.",
    no_google: "The google service is not available in your device.",
    loading: "loading",
    no_loading: "Nothing down below",
    Confirm: "Confirm",
    Pay: "Pay",
    Loading: "Loading",
    payment: "Processing"
  },
  goldModal: {
    conversiongold: "Exchange for coin",
    diamond: "Diamond",
    gold: "Coin",
    MAX: "Max",
    Pay: "Purchase"
  },
  estimate: {
    text: "What's your rate？",
    toast: "Thanks for your Rating"
  },
  appLogin: {
    text: "Please login to continue",
    login: "Please login",
    loginSuccess: "Login successful",
    loginError: " Login failed"
  },
  appTip: {
    title: "Notice",
    text:
      "Games will be unavailable on July 22nd, 5:00 pm - 8:00 pm (GMT+3) due to scheduled server maintenance. We apologize for any inconvenience caused by this.",
    ok: "OK"
  }
};



// WEBPACK FOOTER //
// ./src/assets/common/lang/ja.js